module.exports = __webpack_public_path__ + "images/erp-nation-glad-title.1789440611829.png";